import React, { useState } from "react";
import { Card, CardContent, Grid } from "@material-ui/core";
import VerifyUser from "./verifyUser";
import SendOtp from "./SendOtp";

function Register({ handlePage }) {
    const [email, setEmail] = useState();

    return (
        <>
            <Grid item>
                <Card style={{ borderRadius: "20px", backgroundColor: "#101427", boxShadow: "0 3px 70px #000000" }}>
                    <div style={{ textAlign: "center", marginTop: "20px", fontSize: "18px" }}>
                        <p>Sign Up</p>
                    </div>
                    <CardContent style={{ padding: "30px 50px 20px" }}>
                        {!email ? <SendOtp setEmail={setEmail} /> : <VerifyUser email={email} handlePage={handlePage} />}
                    </CardContent>
                    {!email ? (
                        <div style={{ textAlign: "center" }}>
                            <p>
                                Already registered?{" "}
                                <strong style={{ color: "blue" }} onClick={handlePage}>
                                    sign in here
                                </strong>
                            </p>
                        </div>
                    ) : null}
                </Card>
            </Grid>
        </>
    );
}

export default Register;
